export class LongTermStatus {
    id = -1;

    name = '';

    hideFromDispatchBoard = false;

    allowDispatch = false;

    requiresEndDate = false;

    longTermStatusTypeId = null;

    isPTO = false;

    isFamLTS = false;
}

export const LongTermStatusType = {
    Employee: 1,
    Equipment: 2,
};